export const formatSeconds = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const leftSeconds = Math.floor(seconds % 60);
  const minutesStr = minutes < 10 ? `0${minutes}` : minutes.toString();
  const leftSecondsStr = leftSeconds < 10 ? `0${leftSeconds}` : leftSeconds.toString();
  return `${minutesStr}:${leftSecondsStr}`;
};

export default formatSeconds;